import { render, staticRenderFns } from "./struggling-domain-filter-card.vue?vue&type=template&id=d396129c&scoped=true"
import script from "./struggling-domain-filter-card.ts?vue&type=script&lang=ts&external"
export * from "./struggling-domain-filter-card.ts?vue&type=script&lang=ts&external"
import style0 from "./struggling-domain-filter-card.scss?vue&type=style&index=0&id=d396129c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d396129c",
  null
  
)

export default component.exports